import { Component, ChangeDetectionStrategy, ViewChild, signal } from '@angular/core';

import { TranslocoDirective } from '@ngneat/transloco';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconClockComponent } from '@pedix-workspace/angular-ui-icons';
import { WorkingDays } from '@pedix-workspace/utils';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { WorkingHoursMessageDetailsComponent } from '@pedix-workspace/pedixapp-shared-catalog';

@Component({
    selector: 'pxw-establishment-closed-dialog',
    templateUrl: './establishment-closed-dialog.component.html',
    styleUrls: ['./establishment-closed-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslocoDirective,
        ModalDialogComponent,
        IconClockComponent,
        AlertComponent,
        WorkingHoursMessageDetailsComponent,
    ]
})
export class EstablishmentClosedDialogComponent {
  @ViewChild(ModalDialogComponent) modalDialog: ModalDialogComponent;

  workingDays = signal<WorkingDays | null>(null);

  open(workingDays: WorkingDays | null) {
    this.workingDays.set(workingDays);

    return this.modalDialog.open().catch(() => {});
  }
}
